import styled from 'styled-components';

export const Units = styled.div`
  min-width: 160px;
  padding: 5px 15px;
  background: #fff;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, .15);
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  margin: 10px 0;
  text-transform: uppercase;
  cursor: pointer;

  svg {
    color: ${props => props.theme.colors.primary};
    max-width: 15px;
    margin-right: 5px;
  }
`;
